// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__j-klv","left":"StickyBox_left__2wV3e","right":"StickyBox_right__SpP6G"};